module.exports = __webpack_public_path__ + "static/media/websiteIcon.50358df2.svg";